import React, { Component } from 'react';
import * as ROUTERTJE from 'react-router-dom';
import * as ROUTERTJEa from 'react-router';

// Import HeaderItem
import HeaderItem from './header-item';

// Import menu configuration
import MenuItems from '../../config/navbarItems';

/**
 * This component represents the main navigation of this website
 */

let scrollTimeout;

class Header extends Component {
    constructor(props){
        super(props);

        this.state = {
            mobileMenuActive : false,
            isFloating: false
        };
    }

    componentWillUnmount(){
        document.removeEventListener('scroll', this.onWindowScroll.bind(this), false);

        // Remove route listener
        this.routeListener();
    }

    componentDidMount(){
        this.setState({
            pathname: window.location.pathname

        });

        this.scrollPosition = window.scrollY;

        document.addEventListener('scroll', this.onWindowScroll.bind(this), false);

        // Update route because we'll need some special views on homepage
        this.routeListener = this.props.history.listen((route) => {
            if(route.pathname !== this.state.pathname){
                this.setState({
                    pathname: route.pathname
                })
            }
        });
    }


    onWindowScroll(){
        this.scrollPosition = window.scrollY;

        if(scrollTimeout){
            clearTimeout(scrollTimeout);
        }

        scrollTimeout = setTimeout(() => {requestAnimationFrame(() => this.modifyFloatingStatus())}, 100);
    }


    modifyFloatingStatus(){
        if (this.scrollPosition > 20) {
            if(!this.state.isFloating){
                this.setState({
                    isFloating: true
                })
            }
        } else {
            if(this.state.isFloating){
                this.setState({
                    isFloating: false
                })
            }
        }
    }

    renderMenu(){
        return MenuItems.map((item) => {
            if(item && item.children && item.children.length > 0){
                return this.renderDropdown(item)
            }else{
                return this.renderItem(item)
            }
        })
    }

    renderDropdown(item){
        const subItems = item.children.map((subItem) => {
            return this.renderItem(subItem);
        });

        return (
            <div key={item.name} className="navbar-item has-dropdown is-hoverable">
                {
                    item.to && this.renderItem(item )
                }

                {
                    !item.to && <a className="navbar-link">
                        {item.name}
                    </a>
                }

                <div className="navbar-dropdown">
                    { subItems }
                </div>
            </div>
        )
    }

    renderItem(item){
        return (
            <HeaderItem key={item.to} itemConfig={item} />
        )
    }

    toggleMobileMenu(){
        this.setState({
            mobileMenuActive: !this.state.mobileMenuActive
        })
    }

    render(){
        return (
            <nav className={`navbar ${this.state.pathname === '/' ? 'is-default' : ''} ${this.state.isFloating ? 'is-fixed' : ''}`} role="navigation" aria-label="main navigation">
                <div className="container">
                    <div className="navbar-brand">
                        <HeaderItem itemConfig={{to: '/'}} >
                            <img src={require('../../assets/images/logo-gifture.png')} alt="Gifture: De leukste photobooth die er te huur is!" height="150" />
                        </HeaderItem>
                        <a className={`navbar-burger ${this.state.mobileMenuActive ? 'is-active' : ''}`} onClick={this.toggleMobileMenu.bind(this)}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </a>
                    </div>
                    <div className={`navbar-menu ${this.state.mobileMenuActive ? 'is-active' : ''}`}>
                        <div className="navbar-end">
                            {
                                this.renderMenu()
                            }
                        </div>

                    </div>

                </div>
            </nav>
        )
    }
}


export default Header;


// WEBPACK FOOTER //
// ./src/components/header/index.js